import React, {Fragment} from 'react';

import MultiPageForm from "../Base/ReactMultiPageForm";
import BootstrapRow from "ui/BootstrapRow";

export default class PEPFeedbackConfirm extends MultiPageForm
{
	constructor(props)
	{
		super(props);

		if ( this.props.notes != null )
		{
			this.state.notes = this.props.notes ;
		}
	}

	getFormData()
	{
		return ({});
	}

	onSave() 
	{
		if ( !this.formIsValid())
		{
			this.setState ( { displayErrors : true })
		}
		else
		{
			if ( this.props.onSave != null )
			{
				// Just pass the click back to the creating form
				this.props.onSave( true ) ;
			}	
		}
	}

	onCancel() 
	{
		if ( this.props.onCancel != null )
		{
			this.props.onCancel() ;
		}
		else
		{
			location.assign('home.php');
		}
	}

	render() 
    {

		return (
			<div className='panel panel-default'>
				<div className='panel-heading' key={1}>Feedback</div>
				<div className='panel-body' key={2}>
					<BootstrapRow>
						<div className='col-1 col-md-12'>
							<h3 key='h1'>Thank you for completing this request</h3>
							<h3 key='h2'>By clicking the 'Confirm' button below, you will submit this feedback for inclusion in the pupil's next PEP review.</h3>
							<h3 key='h5'>You will not be able to change this information once it has been submitted so please take this opportunity to review your forms.</h3>
							<h3 key='h4'>When you are happy with your input, please click the submit button below to complete this review.</h3>
						</div>
					</BootstrapRow>
				</div>
				<div className='panel-body' key={3}>
					<div>
						<div className='col-md-9' key={4}></div>
						<div className='col-md-3' style={{ paddingRight: '0px'}} key={5}>
							<button className='btn btn-primary' style={{ float: 'right' }} onClick={this.onNext.bind(this)}>Submit</button>
						</div>
					</div>
				</div>
			</div>
		)
    }
};